import {
  getAuthKeyTypeFromAuthKey,
  AuthKeyType,
} from '@tob/shared/utils/auth-key';
import { LoginMethod, SignupMethod } from './enums';

export const toMonitoringLoginMethod = (authKey: string): LoginMethod =>
  getAuthKeyTypeFromAuthKey(authKey) === AuthKeyType.Email
    ? LoginMethod.EmailOtp
    : LoginMethod.PhoneOtp;

export const toMonitoringSignupMethod = (authKey: string): SignupMethod =>
  getAuthKeyTypeFromAuthKey(authKey) === AuthKeyType.Email
    ? SignupMethod.Email
    : SignupMethod.Phone;
